(function () {
  function initSplit(root) {
    var track = root.querySelector('[data-mhs-track]');
    if (!track) return;
    var panels = track.querySelectorAll('[data-mhs-panel]');
    var dots = root.querySelectorAll('[data-mhs-dot]');
    if (panels.length < 2) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function currentIndex() {
      var w = track.clientWidth || 1;
      return Math.round(track.scrollLeft / w);
    }

    track.addEventListener(
      'scroll',
      function () {
        setActive(currentIndex());
      },
      { passive: true }
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var w = track.clientWidth;
        track.scrollTo({ left: w * i, behavior: 'smooth' });
        setActive(i);
      });
    });

    setActive(0);
  }

  function initBannerCarousel(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mhs-slide]'));
    if (slides.length < 2) return;

    var dotsWrap = root.querySelector('[data-mhs-carousel-dots]');
    var intervalMs = parseInt(root.getAttribute('data-mhs-interval') || '4500', 10);
    if (!intervalMs || intervalMs < 1500) intervalMs = 4500;

    var index = 0;
    var timer = null;
    var dots = [];

    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = slides.map(function (_, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'moyshop-home-stack-hero__carousel-dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        btn.addEventListener('click', function () {
          goTo(i);
          restart();
        });
        dotsWrap.appendChild(btn);
        return btn;
      });
    }

    function goTo(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function next() {
      goTo(index + 1);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      // Only autoplay when this carousel is visible (desktop vs mobile).
      if (!root.offsetWidth && !root.offsetHeight) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(next, intervalMs);
    }

    function restart() {
      start();
    }

    renderDots();
    goTo(0);
    start();

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
    window.addEventListener('resize', function () {
      start();
    });
  }

  function boot() {
    document.querySelectorAll('[data-mhs-split]').forEach(initSplit);
    document.querySelectorAll('[data-mhs-banner-carousel]').forEach(initBannerCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
